export const USER_LOGIN_ROUTE = '/api/auth/login';
export const USER_LOGOUT_ROUTE = '/api/auth/logout';
export const USER_CHANGE_ROUTE = '/api/auth/change';

// Policy
export const POLICY_PAGE_LINK = '/policy/app';
